export default __webpack_public_path__ + "static/media/illustration-algowork-m@3x.eb874f6b.webp";